// 前台投票鈕的總開關（投票頁卡片與步道詳情兩處）。
// 暫時下架投票入口，票數照常顯示；要恢復時改回 true 即可，投票流程本身沒動
export const VOTE_BUTTON_ENABLED = false

// 主題形象蓋章頁的「送出蓋章」鈕，暫時下架的理由與做法同上
export const STAMP_SUBMIT_ENABLED = false
